import { useEffect, useState } from 'react'
import i18n from '../i18n/config'

export function LanguageSwitcher() {
  const [lang, setLang] = useState(i18n.language)

  useEffect(() => {
    const handler = (lng: string) => setLang(lng)
    i18n.on('languageChanged', handler)
    return () => {
      i18n.off('languageChanged', handler)
    }
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value)
  }

  return (
    <select
      className="lang-switcher"
      value={lang}
      onChange={handleChange}
      aria-label="Select language">
      <option value="en-US">English</option>
      <option value="pt-BR">Português</option>
    </select>
  )
}
